import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { CommonHeaderLayoutBuilder } from './common-header-layout.builder';
import { TrackingScreenNamesEnum } from '../../../tracking/tracking.data';
import { ITrackingObject } from 'i2g-ng-tracking';
import { IRouter } from 'i2g-ng-ui';

@Component({
  selector: 'app-common-header-layout',
  templateUrl: './common-header-layout.component.html',
  styleUrls: ['./common-header-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [CommonHeaderLayoutBuilder],
})
export class CommonHeaderLayoutComponent implements OnInit {
  @Input() headerCtaLabel: string;
  @Input() headerCtaRoute: IRouter;
  @Input() trackingScreenName: TrackingScreenNamesEnum;
  @Input() trackingObject: ITrackingObject;
  @Input() showHeaderCta = false;

  loginRoute: IRouter;

  constructor(private _commonHeaderLayoutBuilder: CommonHeaderLayoutBuilder) {}

  ngOnInit() {
    if (this.showHeaderCta) {
      this.headerCtaRoute =
        this.headerCtaRoute ||
        this._commonHeaderLayoutBuilder.buildLoginRoute(
          this.trackingScreenName,
          this.trackingObject
        );
    }
  }
}
